import loadable from '@loadable/component';

export const OrgDashboardBuyCreditsContainerLoadable = loadable(
  () => import('./OrgDashboardBuyCreditsContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardBuyCreditsContainer,
    ssr: false,
  },
);
